import type { CSSProperties, ReactElement } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import { ColorType } from '@/theme/colors';
import { Cicon } from '../Cicon';
import { CTEXTINPUT_CHEVRON_SIZE_PX } from './Ctextinput.constants';

interface CtextinputChevronProps {
  isVisible: boolean;
  opacity: number;
  style: CSSProperties;
}

export function CtextinputChevron({
  isVisible,
  opacity,
  style,
}: CtextinputChevronProps): ReactElement | null {
  if (!isVisible) {
    return null;
  }

  return (
    <Cicon
      icon={IconChevronDown}
      size={CTEXTINPUT_CHEVRON_SIZE_PX}
      color={ColorType.White}
      opacity={opacity}
      style={style}
    />
  );
}
